<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button :disabled="order.orderStatus>0" content="button.taken" icon="vxe-icon-search" mode="text" status="primary" @click="add"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.submit" icon="vxe-icon-signature" mode="text" status="primary" @click="submit"/>
        <vxe-button :disabled="!order.no" content="button.coldChainEdit" icon="vxe-icon-edit" mode="text" status="info" @click="openColdChainEdit"/>
      </template>
      <a-form-model :colon="false" :label-col="labelCol" :model="order" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderNo')">
              <vxe-input v-model="order.no" :disabled="disable" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.owner')">
              <vxe-input v-model="order.owner.name" :disabled="disable" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supplier')">
              <vxe-input v-model="order.customer.name" :disabled="disable" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.invoiceDate')">
              <vxe-input v-model="order.invoiceTime" :disabled="disable" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.PrintOrNot')">
              <vxe-switch v-model="PrintOrNot"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <vxe-card>
      <vxe-table
        ref="table"
        :data="details"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        :loading="loading"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="250"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="asnDetail.quantity" title="business.label.quantity" width="100"/>
        <vxe-column field="asnDetail.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="asnDetail.manufacturer" title="business.label.manufacturer" width="200"/>
        <vxe-column field="asnDetail.producingArea" title="business.label.producingArea" width="100"/>
        <vxe-column field="asnDetail.lotNo" title="business.label.lot" width="150"/>
        <vxe-column field="asnDetail.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="asnDetail.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="purchaseOrder.no" title="business.label.purchaseOrder" width="130"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button :disabled="order.orderStatus>0" content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button :disabled="order.orderStatus>0" content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <AsnDetailEditModal ref="asnDetailEditModal" @success="refresh"/>
    <PoModal ref="poModal" @success="refresh"/>
    <cold-chain-edit-drawer ref="coldChainEditDrawer" @success="refresh"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { AsnDetail, AsnOrder } from '@/api/dto/order/AsnOrder'
import { findAll, findOne, post, querySql } from '@/api/Api'
import api from '@/api'
import PoModal from '@/views/inbound/asn/modal/PoPickupModal.vue'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import AsnDetailEditModal from '@/views/inbound/asn/modal/AsnDetailEditModal.vue'
import ColdChainEditDrawer from '@/views/inbound/asn/drawer/ColdChainEditDrawer.vue'
import { DeviceHandler } from '@/deviceHelper'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  name: 'AsnEdit',
  components: { ColdChainEditDrawer, AsnDetailEditModal, PoModal },
  data() {
    return {
      loading: false,
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      PrintOrNot: false,
      disable: true,
      form: this.$form.createForm(this),
      order: new AsnOrder(),
      details: [],
      page: 1,
      size: 15,
      contentSize: 0,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.7)
    }
  },
  created() {
    this.init()
  },
  props: {
    owners: {
      type: Array,
      default: []
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getDetails()
    },
    init() {
      this.order = new AsnOrder()
      if (!this.order.dataSource) {
        this.order.dataSource = 4
      }
      if (!this.order.operator) {
        this.order.operator = this.operator.name
      }
      this.details = []
    },
    refresh(order) {
      this.order = new AsnOrder(order)
      this.getDetails()
    },
    getDetails() {
      if (this.order.isNew()) return
      this.loading = true
      findAll('asnDetailFactory', { 'order.id': this.order.id }, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.details = res.result
        }
      }).finally(() => this.loading = false)
    },
    fetchOrderById(id) {
      if (id === '' || id === null || id === undefined) {
        return this.$warning({ title: '单据Id为空', centered: true })
      }
      this.loading = true
      findOne('asnOrderFactory', { id: id }).then(res => {
        if (res.success) {
          this.refresh(res.result)
        }
      }).finally(() => this.loading = false)
    },
    edit(row) {
      this.$refs.asnDetailEditModal.open(this.order, new AsnDetail(BaseObject.merge(row, 'asnDetail')))
    },
    add() {
      if (this.order.isNew()) {
        this.$refs.poModal.open()
      } else {
        this.$refs.poModal.open(this.order)
      }
    },
    openColdChainEdit() {
      if (this.order.owner.isNew()) {
        return this.$warning({ title: '无单据信息', centered: true })
      }
      this.$refs.coldChainEditDrawer.open(this.order.no)
    },
    save() {
      this.loading = true
      const order = this.order.toJSONObject()
      order.warehouse = this.warehouse
      post(api.receivingAsnSave, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$success({ title: '保存成功', centered: true })
          this.order = new AsnOrder(res.result)
        }
      }).finally(() => this.loading = false)
    },
    submit() {
      this.loading = true
      const order = this.order.toJSONObject()
      order.warehouse = this.warehouse
      post(api.receivingAsnSubmit, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$success({ title: '提交成功', centered: true })
          this.order = new AsnOrder(res.result)
          if (this.PrintOrNot) { // 根据标识 是否打印
            const body = {
              'query.no': 'asnOrderPrint',
              sql: null,
              args: {
                orderNo: res.result.no
              }
            }
            querySql(body).then(res => {
              if (res.success && res.result.length > 0) {
                const Dt = []
                const printList = []
                res.result.map(item => {
                  item.xq = item.scrq + ' - ' + item.yxq    //效期拼接
                  Dt.push(item)
                })
                if (Dt.length > 0) {
                  printList.push(
                    {
                      'PLAN_CODE': '080090',
                      'WH_ID': 1000000001,
                      'DATA': Dt
                    }
                  )
                  DeviceHandler.printWithDataList(printList, (item, res) => {
                    if (res.hasOwnProperty('msg')) {
                    }
                  })
                }
              }
            })
          }
        }
      }).finally(() => this.loading = false)
    },
    remove(row) {
      const that = this
      this.$confirm({
        title: '明细删除后需重新提取',
        content: that.$t('message.confirmDeleteTip'),
        onOk() {
          that.loading = true
          post(api.receivingAsnDelete, { type: 'normalAsn' }, { id: row.asnDetail.id }).then(res => {
            if (res.success) {
              that.$message.success('删除成功')
              that.getDetails()
            }
          }).finally(() => that.loading = false)
        },
        onCancel() {
        },
        centered: true
      })
    }
  }
}
</script>